import { useDispatch } from 'react-redux';
import dynamic from 'next/dynamic';
import Link from 'next/link';

import { Bottomsheet } from '@com/modal/containers/Bottomsheet';
import { getClientDevice } from '@utilities/client-device';
import { setMapStateAction } from '@redux/map/mapActions';
import { colorPallete } from '@configs/color-pallete';
import { Button } from '@com/_atoms/NewButton';
import useModal from '@hooks/useModal';
import Icon from '@utilities/icon';

const ParsiMapContent = dynamic(
  () => import('@com/_molecules/ParsiMapContent'),
  { ssr: false },
);

type OfficeLocationBottomSheetProps = {
  officeName: string;
  longitude: number;
  latitude: number;
  officeId: number;
};

const OfficeLocationBottomSheet = ({
  longitude,
  officeName,
  latitude,
  officeId,
}: OfficeLocationBottomSheetProps) => {
  const dispatch = useDispatch();
  const { removeLastModal } = useModal();

  const viewport = {
    longitude: longitude,
    latitude: latitude,
    name: officeName,
    id: officeId,
  };

  dispatch(setMapStateAction({ viewport, mapIsTouched: false }));

  const clientDevice = getClientDevice();
  const isAndroidDevice = ['android-pwa', 'android-browser'].includes(
    clientDevice,
  );

  if (isAndroidDevice) {
    removeLastModal();
    window.location.href = `geo:${latitude},${longitude}?q=${latitude},${longitude}`;
    return;
  }

  return (
    <Bottomsheet height={400} title="موقعیت مطب" hasCloseButton>
      <div className="flex items-center gap-4 mb-4 px-4 pt-2">
        <Link
          href={`https://neshan.org/maps/@${latitude},${longitude},15z`}
          className="w-full"
          target="_blank"
        >
          <Button
            iconPosition="right"
            variant="ghost"
            size="small"
            icon={
              <Icon
                fill={colorPallete?.content?.accent}
                name="DiamondArrowTurnRight"
                height={1.25}
                width={1.25}
              />
            }
            className="gap-1 w-full"
          >
            نشان
          </Button>
        </Link>

        <Link
          href={`https://balad.ir/#15.00/${latitude}/${longitude}`}
          className="w-full"
          target="_blank"
        >
          <Button
            iconPosition="right"
            variant="ghost"
            size="small"
            icon={
              <Icon
                fill={colorPallete?.content?.accent}
                name="DiamondArrowTurnRight"
                height={1.25}
                width={1.25}
              />
            }
            className="gap-1 w-full"
          >
            بلد
          </Button>
        </Link>

        <Link
          href={`https://www.google.com/maps/@${latitude},${longitude},15.00z`}
          target="_blank"
          className="w-full"
        >
          <Button
            iconPosition="right"
            variant="ghost"
            size="small"
            icon={
              <Icon
                fill={colorPallete?.content?.accent}
                name="DiamondArrowTurnRight"
                height={1.25}
                width={1.25}
              />
            }
            className="gap-1 w-full"
          >
            گوگل مپ
          </Button>
        </Link>
      </div>

      <div className="relative w-full h-[400px] flex items-center justify-center rounded-xl overflow-hidden">
        <ParsiMapContent height="400px" interactive={false} />
      </div>
    </Bottomsheet>
  );
};

export default OfficeLocationBottomSheet;
